import Icon, { BaseIconProps } from '../icons/react-components/Icon'
function ThumbsDownIcon({ ...props }: BaseIconProps) {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        <path
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M19.503 15.082c-1.132 0-1.997-.904-1.997-2.086V4.094c0-1.182.865-2.086 1.997-2.086s1.997.904 1.997 2.086v8.902c0 1.182-.865 2.086-1.997 2.086Z"
        />
        <path
          stroke="#000"
          strokeMiterlimit={10}
          strokeWidth={2}
          d="M19.475 2H7.703C6.082 2 4.672 3.059 4.46 4.54l-1.832 7.085c-.635 2.611 1.198 3.529 3.242 3.529h3.51c.212 0 .353.212.275.41C8.225 19.366 9.592 22 11.015 22c1.425 0 1.27-1.906 2.116-3.811 1.41-3.106 3.242-3.106 3.665-3.106h2.679"
        />
      </svg>
    </Icon>
  )
}
export default ThumbsDownIcon
